import React, { useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import AuthNavbar from "utils/Navbars/AuthNavbarAdvance.js";
import { Device, DeviceContext } from 'utils/Device';
import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";
import Hidden from "@material-ui/core/Hidden";
import { FormControl, Grid } from "@material-ui/core";

import { useCookies } from 'react-cookie';
import { useHistory } from "react-router-dom";
import { Box, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, Paper } from '@mui/material';

import QuotesDMA from "components/QuotesDMA";
import PoliciesDMA from "components/PoliciesDMA";

import dmaState from "assets/img/Pennsylvania_DMA.jpg";

const useStyles = makeStyles(styles);

const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);

    React.useEffect(() => {
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });
    return matches;
};

var obj;
export default function Pages(props) {
    const [cookies, setCookie] = useCookies(['auth']);
    //Helper functions
    function isNotNull(data) {
        if (data == null || data == "") {
            return false;
        } else {
            return true;
        }
    }

    //Event Handlers
    const changeStartDate = (date) => {
        setStartDate((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    };

    const changeEndDate = (date) => {
        setEndDate((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    };

    const changeCall = () => {
        setCall("true");
    };
    const changeGroupDateBy = (selected) => {
        setGroupDateBy(selected);
    };
    //Events End

    //State Variables 
    var date = new Date();
    // var startdate = date.setDate(date.getDate() - 32);
    //startDate = Date.
    const [startDate, setStartDate] = React.useState((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    const [endDate, setEndDate] = React.useState((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    const [groupDateBy, setGroupDateBy] = React.useState("Day");
    const [call, setCall] = React.useState(false);
    const [imageLoaded, setImageLoaded] = React.useState(false);

    const device = Device();
    const { ...rest } = props;
    // ref for the wrapper div
    const wrapper = React.createRef();
    // styles
    const classes = useStyles();

    //When user refresh page or submit new dates, get all the data
    React.useEffect(() => {
        if (call == "true" || call == null) {
            //setQuoteTotalPip(null);
            //Refresh();
        }


        return () => {
            //End
            setCall("false");

        }
    }, [call]);

    //Utility functions
    const getActiveRoute = routes => {
        let activeRoute = "Default Brand Text";
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                let collapseActiveRoute = getActiveRoute(routes[i].views);
                if (collapseActiveRoute !== activeRoute) {
                    return collapseActiveRoute;
                }
            } else {
                if (
                    window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
                ) {
                    return routes[i].name;
                }
            }
        }
        return activeRoute;
    }
    const history = useHistory();
    if (cookies.pass == undefined) {
        history.push('/');
    }
    //Utility functions End

    return (
        <DeviceContext.Provider value={device}>
            <div>
                <div className={classes.wrapper} ref={wrapper}>
                    <AuthNavbar onChangeCall={changeCall} onChangeStartDate={changeStartDate} onChangeEndDate={changeEndDate} onChangeGroupDateBy={changeGroupDateBy} startDate={startDate} endDate={endDate} groupDateBy={groupDateBy} state="PA" Text={"Pennsylvania Dashboard"} {...rest} />
                    <div>
                        <Grid container>
                            <Grid item xs={12} sm={12}>
                                <Hidden smDown>
                                    <h1 style={{ textAlign: "center", fontWeight: "bold", color: "rgb(29, 76, 128)" }} >PENNSYLVANIA DESIGNATED MARKETING AREAS</h1>
                                </Hidden>
                                <Hidden mdUp>
                                    <h3 style={{ textAlign: "center", fontWeight: "bold", color: "rgb(29, 76, 128)" }} >PENNSYLVANIA DESIGNATED MARKETING AREAS</h3>
                                </Hidden>
                            </Grid>
                            <Hidden mdDown>
                                <Grid item xs={12} lg={3} ></Grid>
                            </Hidden>
                            <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                                <Box
                                    sx={{
                                        position: 'relative',
                                        width: device.isMobile ? '100%' : '90%',
                                        maxWidth: device.isMobile ? 800 : 900,
                                        margin: '0 auto',
                                        display: 'flex',
                                        justifyContent: 'flex-end'
                                    }}
                                >
                                    <img
                                        src={dmaState}
                                        alt="Pennsylvania State"
                                        style={{ width: device.isXs ? '100%' : device.isMobile ? '65%' : '70%', display: 'block' }}
                                        onLoad={() => setImageLoaded(true)}
                                    />
                                    {!device.isXs && imageLoaded && <DMAPopulationTable device={device} />}
                                </Box>
                                {device.isXs && imageLoaded && <DMAPopulationTable device={device} />}
                            </Grid>
                            <Grid item xs={12}>
                                <QuotesDMA
                                    startDate={startDate}
                                    endDate={endDate}
                                    call={call}
                                    groupBy={groupDateBy}
                                    state={'PA'}
                                />
                            </Grid>
                            <PoliciesDMA
                                startDate={startDate}
                                endDate={endDate}
                                call={call}
                                groupBy={groupDateBy}
                                state={'PA'}
                            />
                        </Grid>
                    </div>
                </div>
            </div>
        </DeviceContext.Provider>
    );
}

const DMAPopulationTable = (props) => {
    return (
        <TableContainer
            component={Paper}
            sx={{
                position: props.device.isXs ? 'relative' : 'absolute',
                bottom: props.device.isXs ? 10 : props.device.isMobile ? '5%' : 55, // Distance from the bottom edge
                left: props.device.isXs ? '10%' : props.device.isMobile ? '3.5%' : 0, // Distance from the left edge
                width: props.device.isXs ? '90%' : props.device.isMobile ? '30%' : 230,
                maxWidth: props.device.isXs ? '80%' : 230,
                overflowX: 'hidden',
                boxShadow: 3, // Adds elevation depth over the image
                '& .MuiTableCell-root': {
                    borderColor: '#e0e0e0', // Clean light border lines
                    padding: props.device.isMobile ? 'calc(3px + 0.25vw)' : '5px', // Added slightly more horizontal padding
                    fontSize: props.device.isMobile ? 'calc(9px + 0.25vw)' : '1em',
                },
                '& th.MuiTableCell-head': {
                    backgroundColor: (theme) => theme.palette.common.black,
                    color: (theme) => theme.palette.common.white,
                    fontWeight: 'bold',
                },
                '& tbody tr': {
                    backgroundColor: '#ffffff',
                    '& .MuiTableCell-body': {
                        color: 'rgba(0, 0, 0, 0.87)' // High contrast black body text
                    }
                },
                '& tbody tr:nth-of-type(odd)': {
                    backgroundColor: '#f5f5f5', // Soft, standard light gray theme
                },
                '& tbody tr:last-child td': {
                    borderBottom: '1px solid #e0e0e0' // Matches bottom edge of your image
                }
            }}
        >
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>DMA</TableCell>
                        <TableCell align="center">Population</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell align="center">Philadelphia</TableCell>
                        <TableCell align="right">5,386,671</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align="center">Pittsburgh</TableCell>
                        <TableCell align="right">2,661,395</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align="center">Harrisburg-Lancaster-Lebanon-York</TableCell>
                        <TableCell align="right">2,030,345</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align="center">Wilkes Barre-Scranton-Hazleton</TableCell>
                        <TableCell align="right">1,476,115</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align="center">Johnstown-Altoona-State College</TableCell>
                        <TableCell align="right">723,879</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align="center">Erie</TableCell>
                        <TableCell align="right">384,662</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell style={{ fontSize: props.device.isMobile ? '0.65em' : '0.7em', backgroundColor: '#ffffff' }}>Data as of July 2025</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};
